<template>
  <div class="new-form-step-content">
    <form @submit.prevent="submitFrom3">
      <!-- Instagram Input -->
      <div class="input-icon-container margin-bottom-16">
        <div class="input-icon">
          <img src="/images/new creators form/instagram.svg" alt="" />
        </div>
        <input
          type="text"
          class="new-form-control new-form-control-includes-icon"
          id="instagram_url"
          name="instagram_url"
          :placeholder="
            $store.state.creatorSignupPage?.NewCForm1?.FormStep1
              ?.instagramPlaceholder
          "
          v-model="FormData.instagram_url"
          :class="{ 'is-invalid': FromErrorFlags.instagram_url }"
          @input="() => { clearError('instagram_url'); emitValueChange(); }"
        />
      </div>
     

      <!-- TikTok Input -->
      <div class="input-icon-container margin-bottom-16">
        <div class="input-icon">
          <img src="/images/new creators form/tik-tok.svg" alt="" />
        </div>
        <input
          type="text"
          class="new-form-control new-form-control-includes-icon"
          id="tiktok"
          name="tiktok"
          :placeholder="
            $store.state.creatorSignupPage?.NewCForm1?.FormStep1
              ?.tiktokPlaceholder
          "
          v-model="FormData.tiktok"
          :class="{ 'is-invalid': FromErrorFlags.tiktok }"
          @input="() => { clearError('tiktok'); emitValueChange(); }"
        />
      </div>

      <!-- YouTube Input (COMMENTED OUT - Text input approach) -->
      <!-- <div class="input-icon-container margin-bottom-16">
        <div class="input-icon">
          <img src="/icons/youtube-icon.svg" alt="" />
        </div>
        <input
          type="text"
          class="new-form-control new-form-control-includes-icon"
          id="youtube_custom_url"
          name="youtube_custom_url"
          placeholder="YouTube Channel ID"
          v-model="FormData.youtube_custom_url"
          :class="{ 'is-invalid': FromErrorFlags.youtube_custom_url }"
          @input="() => { clearError('youtube_custom_url'); emitValueChange(); }"
        />
      </div> -->

      <!-- YouTube Connect Button -->
      <div class="youtube-connect-container margin-bottom-16">
        <button
          type="button"
          class="youtube-connect-button"
          @click="handleYouTubeConnect"
        >
          <svg class="youtube-icon" viewBox="0 -3 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289" transform="translate(-244.000000, -7282.000000)" />
          </svg>
          <span>{{ youtubeChannelInfo?.customUrl || 'Connect YouTube Channel' }}</span>
        </button>
      </div>

      <!-- Terms Checkbox -->
      <div
        class="terms-container d-flex w-100 gap-16 margin-left-08 checkbox-label-container"
      >
        <div class="checkbox-container">
          <input
            type="checkbox"
            id="custom-checkbox"
            class="custom-checkbox"
            v-model="acceptedTerms"
          />
          <label for="custom-checkbox" class="checkbox-label"></label>
        </div>
        <label for="custom-checkbox" class="terms-label">
          {{
            $store.state.creatorSignupPage?.NewCForm1?.FormStep1
              ?.acceptTermsPrivacy
          }}
          <a
            :href="$store.state.creatorSignupPage?.NewCForm1?.links?.terms"
            target="_blank"
            rel="noopener noreferrer"
            class="new-form-color-primary"
          >
            {{ $store.state.creatorSignupPage?.NewCForm1?.FormStep1?.Terms }}
          </a>

          &amp;
          <a
            :href="$store.state.creatorSignupPage?.NewCForm1?.links?.privacy"
            target="_blank"
            rel="noopener noreferrer"
            class="new-form-color-primary"
          >
            {{
              $store.state.creatorSignupPage?.NewCForm1?.FormStep1?.Privacy
            }}</a
          >
        </label>
      </div>
    </form>
  </div>
</template>

<script>
import { axiosAPI } from "../../../../axiosClient";
import { toast } from "vue3-toastify";

export default {
  name: "CreatorForm3Ver2",
  props: {
    creatorId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      FormData: {
        instagram_url: "",
        tiktok: "",
        // youtube_custom_url: "", // Commented out - using OAuth instead
      },
      FromErrorFlags: {
        instagram_url: false,
        tiktok: false,
        // youtube_custom_url: false, // Commented out - using OAuth instead
      },
      acceptedTerms: false,
      creator_id: this.creatorId,
      youtubeConnected: false,
      youtubeChannelInfo: null,
    };
  },
  mounted() {
    // Listen for messages from the OAuth popup
    window.addEventListener('message', this.handleOAuthMessage);
    // Store popup reference outside Vue's reactive system to avoid cross-origin errors
    this._youtubePopup = null;
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('message', this.handleOAuthMessage);
    // Clean up popup reference
    if (this._youtubePopup) {
      try {
        if (!this._youtubePopup.closed) {
          this._youtubePopup.close();
        }
      } catch (e) {
        // Ignore cross-origin errors
      }
      this._youtubePopup = null;
    }
  },
  methods: {
    handleYouTubeConnect() {
      this.youtubeConnected = false;
      this.youtubeChannelInfo = null;
      // Close existing popup if it exists
      if (this._youtubePopup) {
        try {
          if (!this._youtubePopup.closed) {
            this._youtubePopup.close();
          }
        } catch (e) {
          // console.warn('🎬 [YouTube Connect] Error closing existing popup:', e);
        }
        this._youtubePopup = null;
      }

      // Get environment variables
      const clientId = process.env.VUE_APP_CLIENT_ID;
      const redirectUri = process.env.VUE_APP_REDIRECT_URI;

      console.log('🎬 [YouTube Connect] Configuration check:', {
        clientId: clientId ? '✓ Present' : '✗ Missing',
        redirectUri: redirectUri ? '✓ Present' : '✗ Missing'
      });

      if (!clientId || !redirectUri) {
        // console.error('❌ [YouTube Connect ERROR] Missing YouTube OAuth configuration:', {
        //   clientId: !!clientId,
        //   redirectUri: !!redirectUri
        // });
        toast.error("YouTube configuration is missing. Please contact support.", {
          toastId: "youtube-config-missing"
        });
        return;
      }

    
      const extraData = {
        creator_id: this.creator_id,
      };
      const state = btoa(JSON.stringify(extraData));

 
      const scope = 'https://www.googleapis.com/auth/youtube.readonly';


      const url =
        `https://accounts.google.com/o/oauth2/v2/auth` +
        `?client_id=${clientId}` +
        `&redirect_uri=${redirectUri}` +
        `&response_type=code` +
        `&scope=${scope}` +
        `&access_type=offline` +
        `&prompt=consent` +
        `&state=${state}`;

      // Log for testing purposes
      // console.log("YouTube OAuth URL:", url);
      // console.log("State (decoded):", extraData);

      // Open OAuth in a centered popup window
      const width = 500;
      const height = 600;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      this._youtubePopup = window.open(
        url,
        'youtube-oauth',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );

      // Check if popup was blocked
      if (!this._youtubePopup || this._youtubePopup.closed) {
        // console.error('❌ [YouTube Connect ERROR] Popup was blocked by browser');
        toast.error("Popup was blocked. Please allow popups for this site.", {
          toastId: "popup-blocked"
        });
      } else {
        // console.log('✅ [YouTube Connect SUCCESS] OAuth popup opened successfully');
      }
    },

    handleOAuthMessage(event) {
      // console.log('📨 [YouTube OAuth] Received message from:', event.origin);

      // Verify the message origin for security
     const allowedOrigin = process.env.VUE_APP_REDIRECT_URI
       ? new URL(process.env.VUE_APP_REDIRECT_URI).origin
       : window.location.origin;

      if (event.origin !== allowedOrigin && event.data.type !== 'youtube-oauth') {
        // console.warn('⚠️ [YouTube OAuth WARNING] Received message from unauthorized origin:', event.origin, 'Expected:', allowedOrigin);
        return;
      }

      // Close the popup if still open and clean up reference
      if (this._youtubePopup) {
        try {
          if (!this._youtubePopup.closed) {
            this._youtubePopup.close();
          }
        } catch (e) {
          // Ignore errors when accessing closed popup
        }
        this._youtubePopup = null;
      }

      // Check if backend processed successfully
      if (event.data.status === 'success' && event.data.channel) {
        // Backend successfully connected YouTube
        this.youtubeConnected = true;
        this.youtubeChannelInfo = event.data.channel;

        // Show success message with channel name
        toast.success(`YouTube channel "${event.data.channel.customUrl}" connected successfully!`, {
          toastId: "youtube-connected",
          autoClose: 5000
        });

        // Emit event with channel info
        this.$emit('youtube-connected', {
          status: 'success',
          channel: event.data.channel
        });

        // Trigger value change to update button text
        this.emitValueChange();
      } else {
        if (event.data.status === 'error') {
          const message =
            event.data?.message && String(event.data.message).trim()
              ? event.data.message
              : "Failed to process YouTube connection.";

          toast.error(message, {
            toastId: "youtube-process-error"
          });
        }
      }
    },

    validateForm() {
      let valid = true;
      this.resetErrorFlags();

      const instagramUsernamePattern = /^[a-zA-Z0-9._]{1,30}$/;
      this.FormData.instagram_url = this.FormData.instagram_url.trim();
      if (this.FormData.instagram_url) {
        if (!instagramUsernamePattern.test(this.FormData.instagram_url)) {
          this.FromErrorFlags.instagram_url = true;
          toast.error(
            "Instagram username is invalid. Only letters, numbers, periods, and underscores are allowed.",
            {
              toastId:
                "Instagram username is invalid. Only letters, numbers, periods, and underscores are allowed.",
            }
          );
          valid = false;
        }
      }
      this.FormData.tiktok = this.FormData.tiktok.trim();
      if (this.FormData.tiktok && /[^A-Za-z0-9._]/.test(this.FormData.tiktok)) {
        this.FromErrorFlags.tiktok = true;
        toast.error("TikTok username contains invalid characters.", {
          toastId: "TikTok username contains invalid characters.",
        });
        valid = false;
      }

      // Validate YouTube custom URL (optional field) - COMMENTED OUT - using OAuth instead
      // this.FormData.youtube_custom_url = this.FormData.youtube_custom_url.trim();
      // if (this.FormData.youtube_custom_url && /[^A-Za-z0-9._-]/.test(this.FormData.youtube_custom_url)) {
      //   this.FromErrorFlags.youtube_custom_url = true;
      //   toast.error("YouTube channel ID contains invalid characters.", {
      //     toastId: "YouTube channel ID contains invalid characters.",
      //   });
      //   valid = false;
      // }

      if (!this.acceptedTerms) {
        toast.error(
          "You must accept the terms and privacy policy to proceed.",
          {
            toastId: "You must accept the terms and privacy policy to proceed.",
          }
        );
        valid = false;
      }

      return valid;
    },

    resetErrorFlags() {
      for (const field in this.FromErrorFlags) {
        this.FromErrorFlags[field] = false;
      }
    },

    clearError(field) {
      if (this.FromErrorFlags[field]) {
        this.FromErrorFlags[field] = false;
      }
    },

    async submitFrom3() {
      this.resetErrorFlags();
      const isValid = this.validateForm();
      if (!isValid) return false;

      // Check if TikTok field is empty or not, and emit the status
      const isTikTokFilled = !!this.FormData.tiktok.trim();
      // Check if insta field is empty or not, and emit the status
      const isInstagramFilled = !!this.FormData.instagram_url.trim();
      // Check if YouTube field is empty or not - COMMENTED OUT - using OAuth instead
      // const isYouTubeFilled = !!this.FormData.youtube_custom_url.trim();
      //this.$emit("tiktokFilled", isTikTokFilled); // Emit the value to the parent
      console.log("Emitting TikTok Filled Status:", isTikTokFilled);

      const formDataToSend = {
        instagram_url: this.FormData.instagram_url,
        tiktok: this.FormData.tiktok,
        // youtube_custom_url: this.FormData.youtube_custom_url, // Commented out - using OAuth instead
        creator_id: this.creator_id,
        step: 3,
      };

      try {
        const response = await axiosAPI.post(
          "/v1/creator/signup",
          formDataToSend
        );

        if (response.data && response.data.status) {
          this.$emit("submitForm", {
            status: response.data.status,
            instagramPin: response.data.data.instagramPin,
            tikTokPin: response.data.data.tiktokPin,
            tiktokFilled: isTikTokFilled, // Emit TikTok status within the same event
            instagramFilled: isInstagramFilled, // Emit instagram status within the same event
          });

          return {
            status: response.data.status,
            instagramPin: response.data.data.instagramPin,
            tikTokPin: response.data.data.tiktokPin,
            tiktokFilled: isTikTokFilled, // Return TikTok status as part of the result
            instagramFilled: isInstagramFilled, // Return instagram status as part of the result
            // youtubeFilled: isYouTubeFilled, // Commented out - using OAuth instead
          };
        } else {
          toast.error(response.data.message || "Submission failed.", {
            toastId: response.data.message || "Submission failed3.",
          });
          return { status: response.data.status };
        }
      } catch (error) {
        toast.error("An unexpected error occurred. Please try again.", {
          toastId: "An unexpected error occurred. Please try again.3",
        });
        return { status: false };
      }
    },
    emitValueChange() {
      this.$emit('form3-value-change', {
        ...this.FormData,
        youtube_connected: this.youtubeConnected
      });
    }
  },
};
</script>

<style scoped>
.gap-16 {
  gap: 1rem;
}
.margin-left-08 {
  margin-left: 0.5rem;
}
.margin-bottom-16 {
  margin-bottom: 1rem;
}
.instagram_url-label {
  display: block;
  text-align: left;
  margin: 7px 0 24px 16px;
  font-size: 15px;
  color: #00a4b6;
}
.new-form-color-primary {
  color: #00a4b6;
}
.terms-label {
  font-size: 15px;
}
.terms-container {
  margin-top: 69px;
  margin-bottom: -10px;
}
.is-invalid {
  outline: 1px solid red;
}

/* YouTube Connect Button Styles */
.youtube-connect-container {
  width: 100%;
}

.youtube-connect-button {
  width: 100%;
  padding: 15px 20px;
  background-color: #E63946;
  color: #ffffff;
  border: 1.5px solid transparent;
  border-radius: 18px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
}

.youtube-connect-button span {
  color: #ffffff;
  transition: color 0.3s;
}

.youtube-connect-button:hover {
  background-color: #fff;
  color: #E63946;
  border-color: #E63946;
}

.youtube-connect-button:hover span {
  color: #E63946;
}

.youtube-icon {
  width: 20px;
  height: 20px;
  fill: #ffffff;
  transition: fill 0.3s;
}

.youtube-connect-button:hover .youtube-icon {
  fill: #E63946;
}
</style>
